const applyFade = target => {
  const maxScrollLeft = target.scrollWidth - target.clientWidth;
  const targetAbsoluteScroll = Math.abs(target.scrollLeft);
  if (targetAbsoluteScroll >= maxScrollLeft - 10) {
    // @ts-ignore
    target.classList.add(...['unfade-end']);
    target.classList.remove(...['fade-end']);
  } else {
    target.classList.add(...['fade-end']);
    target.classList.remove(...['unfade-end']);
  }
  if (targetAbsoluteScroll <= 10) {
    target.classList.remove(...['fade-start']);
    target.classList.remove(...['fade-end']);
  } else {
    target.classList.add(...['fade-start']);
  }
};
export { applyFade };